import { Component, inject, input, output, viewChild, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Store } from '@ngrx/store';
import { EditorMenuId } from '@src/suite/common/enums/enums';
import { MenuItem } from '@src/suite/common/st-full-screen-dialog/stories-full-screen/story-full-screen/story-actions';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

@Component({
    selector: 'st-editor-menu',
    templateUrl: './editor-menu.component.html',
    styleUrl: './editor-menu.component.scss',
    host: {
        class: 'st-editor-menu',
    },
    encapsulation: ViewEncapsulation.None,
})
export class EditorMenuComponent {
    store = inject(Store);
    items = input<MenuItem[]>([]);
    baseMenu = viewChild<MatMenu>('baseMenu');
    onAction = output<MenuItem>();

    EditorMenuId = EditorMenuId;

    languageSettings = this.store.selectSignal(selectI18N)();

    onActionClick(item: MenuItem) {
        if (item) {
            this.onAction.emit(item);
        }
    }
}
